import React from "react";
import * as actions from './Actions';
import Service from '../service/Service';
const service = new Service();

export default function UserListOverlay({ eleRef }) {
    return (
        <div className="followers-overlay pfLikePopup" onClick={ (e) => actions.closeUserlist(e)}>
            <div className="followers-popup">
                <div className="like-header">
                    <span className="M14_white followers-title"></span>
                    <span className="closeButton icon" data-icon-font="s" onClick={ (e) => actions.closeUserlist(e)}></span>
                </div>
                <div className="like-list">
                </div>
            </div>
        </div>
    );
}
